import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  watch: {
    chartdata: function (chartdata) {
      this.setChart(chartdata)
    }
  },
  mounted() {
    // this.renderChart(this.chartdata, this.options)
    this.setChart(this.chartdata)
  },
  methods: {
    setChart(chartdata) {
      console.log('chartdata :>> ', chartdata);
      this.renderChart(chartdata, this.options)
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/ChartComponents/PieChart.js